"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwsMediaConvertStreamName = exports.AwsMediaConvertOutputGroupDetail = exports.AwsMediaConvertInputDetail = void 0;
var input_detail_1 = require("./input-detail");
Object.defineProperty(exports, "AwsMediaConvertInputDetail", { enumerable: true, get: function () { return input_detail_1.AwsMediaConvertInputDetail; } });
var output_group_detail_1 = require("./output-group-detail");
Object.defineProperty(exports, "AwsMediaConvertOutputGroupDetail", { enumerable: true, get: function () { return output_group_detail_1.AwsMediaConvertOutputGroupDetail; } });
var stream_name_1 = require("./stream-name");
Object.defineProperty(exports, "AwsMediaConvertStreamName", { enumerable: true, get: function () { return stream_name_1.AwsMediaConvertStreamName; } });
